import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation, SecurityContext } from '@angular/core';
import { CalendarContent, CalendarOptions, FullCalendarComponent, ScrollGridImpl } from '@fullcalendar/angular'; // useful for typechecking
import { HttpService } from '../../services/http-service/http.service'
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { AppToastComponent as ToastComp } from '../../services/shared-service/toast-simple/toast.component'
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { ValidationService } from '../../services/validation-service/validation.service';
import { StorageService } from '../../services/storege-service/storage.service';
import * as moment from 'moment';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { DomSanitizer } from '@angular/platform-browser';
import { ToolService } from '../../services/tool/tool.service';

@Component({
  selector: 'app-full-calendar-ng',
  templateUrl: './data-tables.component.html',
  styleUrls: ['./data-tables.component.scss',
  "../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css"]
})
export class FullCalendarNgComponent implements OnInit, AfterViewInit {

  public dbData?;
  public dbDataBO?;
  public dbCourtData?;
  public dbCourtDataBO?;
  public courts?;
  public bookingCategories?;
  public coaches?;
  public paymentMethods?;
  public timingSlots?;
  public bookingAddons?;
  public bookingAddonInstances?;
  public disabledData?;
  public isLoading: boolean = true;
  public ownerId;
  public facilityId;
  public bookingId;
  public bookingName;
  public bookingMobile;
  public bookingCountryCode;
  public bookingDate;
  public bookingStartTime;
  public bookingEndTime;
  public bookingPrice;
  public bookingAddon;
  public bookingVAT;
  public bookingTotal;
  public bookingPayAmount;
  public bookingPayStatus?;
  public bookingPayDate;
  public bookingReOccur: boolean = false;
  public bookingReOccurDays;
  public bookingReOccurInstance;
  public bookingTotalWithReoocur;
  public courtPrice;
  public courtPrice30min = 0.0;
  public courtPrice60min = 0.0;
  public courtPrice90min = 0.0;
  public courtPrice120min = 0.0;
  public taxPercentage = 0;
  public ccy;
  public selectedReoccurDay;
  public bookingNotes: string;
  public bookingAddonsArray:Array<{id: number, name: String, count: number, price: number}> = [];
  //public bookingAddonsObject :object = [];
  public existingBookingAddonArray;
  totalRemainingAmount = 0.0
  public totalDiscount = 0.0;
  public calendarCurrentDate = new Date();
  public courtsList = Array();
  public timingList = Array();
  public state = [false, true];
  public bookingReoccurDisabledDate;
  public taxOnus;
  public membershipDescription: string;
  public membershipName: string;
  public memberId?;
  public calendarTimeSlots? = '00:30:00';
  calendarDate = new Date();
  bookingCategoryId?: string;
  coachId?: string;

  public responseData?;
  public dbActiveData? = Array();
  
  simpleForm: FormGroup;
  isUpdate: boolean = false;
  isError: boolean = false;
  isReoccur: string = '0';
  isAddonBtn: boolean = false;
  court?: string;
  addon?: string;
  paymentMethod?: string;
  endTiming?: string;
  isBookingReoccur: boolean = false;

  today = new Date();
  todayStr: string = this.today.toISOString().replace(/T.*$/, '');
  viewTime: '17:00';

  //events = this.dbData;
  public openEvent(info) {
    this.toolService.showConsoleLog(info);
  }
    
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  @ViewChild('openEventModal', {static: false},) public openEventModal: ModalDirective;
  @ViewChild('addBookingModal', {static: false}) public addBookingModal: ModalDirective;
  @ViewChild('reoccurBookingModal', {static: false}) public reoccurBookingModal: ModalDirective;
  @ViewChild(ToastComp) toastComp: ToastComp;


  constructor(
    private httpService: HttpService, 
    private fb: FormBuilder, 
    private router: Router, 
    public route: ActivatedRoute,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private validationSrv : ValidationService,
    private storageSrv: StorageService,
    private sanitizer: DomSanitizer,
    private tippyService: NgxTippyService,
    public toolService: ToolService,
    ) {
      this.calendarTimeSlots = this.storageSrv.getCalendarTimeSlots();
  }

  calendarOptions: CalendarOptions = {
    initialDate: this.calendarCurrentDate,
    weekNumberCalculation: 'ISO',
    height: 'parent',
    contentHeight: 'auto',
    //eventMinHeight: 50,
    //eventShortHeight: 50,
    // dayMinWidth: 250,
    // aspectRatio: 5,
    initialView: 'resourceTimeGridDay',
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: 'resourceTimeGridDay,timeGridWeek,listWeek',
    },
    views: {
      dayGrid: {
        // options apply to dayGridMonth, dayGridWeek, and dayGridDay views
      },
      day: {
        // options apply to dayGridDay and timeGridDay views
      },
      resourceTimeGridDay: {
        type: 'resourceTimeGrid',
        duration: { days: 1 },
        buttonText: '1 day',
        titleFormat: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      },
    },
    editable: true,
    selectable: true,
    navLinks: true,
    slotDuration: this.calendarTimeSlots == null ? '00:30:00' : this.calendarTimeSlots,
    nowIndicator: true,
    allDaySlot: false,
    datesAboveResources:true,
    expandRows: true,
    eventOrder:'resourceId',
    datesSet: () => {
      var calDate = document.getElementById('calendarDate') as HTMLInputElement;
      let calendarApi = this.calendarComponent?.getApi();
      // this.toolService.showConsoleLog("this.calendarComponent?.getApi().getDate()")
      // this.toolService.showConsoleLog(calendarApi?.getDate())
      // this.toolService.showConsoleLog("calDate.valueAsDate")
      // this.toolService.showConsoleLog(calDate.valueAsDate)

      if (calendarApi?.getDate() != calDate.valueAsDate && calendarApi?.getDate() != undefined)
      {
        calDate.valueAsDate = moment(calendarApi?.getDate()).add(1, 'days').toDate();
        //this.toolService.showConsoleLog(calDate.valueAsDate)
      }
    },
    // businessHours: {
    //   // days of week. an array of zero-based day of week integers (0=Sunday)
    //   daysOfWeek: [0,1,2,3,4,5,6], // Monday - Thursday
    //   startTime: '08:00', // a start time (10am in this example)
    //   endTime: '23:00', // an end time (6pm in this example)
    // },
    viewDidMount: () => {
      var calDate = document.getElementById('calendarDate') as HTMLInputElement;
      calDate.valueAsDate = this.calendarDate;
      let calendarApi = this.calendarComponent?.getApi();
      this.toolService.showConsoleLog("this.calendarTimeSlots");
      this.toolService.showConsoleLog(this.calendarTimeSlots);
      this.toolService.showConsoleLog(this.storageSrv.getCalendarTimeSlots());
      //calendarApi?.setOption("slotDuration", this.calendarTimeSlots);
    },
    eventClick: (selectedBooking) => 
    {
       if (selectedBooking.event.extendedProps?.eventType == 'booking')
       {
         this.manageBooking(selectedBooking)
       }
       else if (selectedBooking.event.extendedProps?.eventType == 'reoccur')
       {
        this.manageReoccurBooking(selectedBooking);
        //this.toastr.info('This booking can only be modified from the bookings menu', "Reccurrant Booking");
       }
       else
       {
         ''
       }
    },
    select: (selectedBooking) => {this.addBooking(selectedBooking)},
    schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives'
  };

  createForm() {
      this.simpleForm = this.fb.group({
      //calendarDate: [this.calendarCurrentDate],
      calendarDate: {value: this.calendarDate},
      bookingId: {value: this.bookingId, disabled:true},
      court: [this.court, [Validators.required]],
      paymentMethod: [this.paymentMethod],
      endTiming: [this.endTiming],
      addon: [this.addon],
      bookingAddonInstances: {value: this.bookingAddonInstances, disabled:true},
      bookingName: [this.bookingName, [Validators.required]],
      bookingMobile: [this.bookingMobile, [Validators.required]],
      bookingCountryCode: [this.bookingCountryCode, [Validators.required]],
      bookingCategoryId: [this.bookingCategoryId],
      coachId: [this.coachId],
      bookingNotes: [this.bookingNotes],
      bookingDate: [this.bookingDate, [Validators.required]],
      bookingStartTime: [this.bookingStartTime, [Validators.required]],
      //bookingEndTime: [this.bookingEndTime, [Validators.required]],
      bookingPrice: {value: this.bookingPrice, disabled:false},
      bookingAddon: {value: this.bookingAddon, disabled:true},
      bookingVAT: {value: this.bookingVAT, disabled:true},
      bookingTotal: {value: this.bookingTotal, disabled:true},
      totalDiscount: {value: this.totalDiscount},
      totalRemainingAmount: {value: this.totalRemainingAmount, disabled:true},
      bookingPayAmount: {value: this.bookingPayAmount, disabled:true},
      bookingPayStatus: {value: this.bookingPayStatus, disabled:true},
      bookingPayDate: {value: this.bookingPayDate, disabled:true},
      bookingReOccur: {value: this.bookingReOccur},
      bookingReOccurDays: {value: this.bookingReOccurDays, disabled:true},
      bookingReOccurInstance: {value: this.bookingReOccurInstance, disabled:true},
      bookingTotalWithReoocur: {value: this.bookingTotalWithReoocur, disabled:true},
    }, { });
  }

  ngOnInit(): void {
    this.simpleForm = this.fb.group({});
    this.validationSrv.validateAcess()
    .then(async () => {
      this.route.queryParams.subscribe(async params => {
       this.getCurrentData();
    });
    });
  }
  async getCurrentData(){
    this.facilityId = this.storageSrv.getFacilityId();
    this.ownerId = this.storageSrv.getUser();
    await this.loadCourts(this.facilityId);
    await this.loadAddons(this.facilityId);
    await this.loadCourtsCalendar(this.facilityId);
    await this.loadBookingsCalendar(this.facilityId);
    await this.loadBookingCategory(this.facilityId);
    await this.loadCoaches();
    //await this.loadDisabledCalendar(this.facilityId);
    await this.loadPaymentMethods(this.facilityId);
    await this.loadTimingSlots(this.facilityId);
    await this.createForm();
    await this.ngAfterViewInit();
    this.isLoading = false;
    this.calendarOptions.initialDate = this.calendarCurrentDate;
    this.toolService.showConsoleLog("this.calendarTimeSlots.toString()");
    this.toolService.showConsoleLog(this.calendarTimeSlots.toString());
    this.calendarOptions.slotDuration = this.calendarTimeSlots.toString() == 'null' ? '00:30:00' : this.calendarTimeSlots;
    await this.updateCalendar();
  }

  toggleChange(event) 
  {
    this.isLoading = true;
    const calendarApi = this.calendarComponent?.getApi();

    if (event.checked)
    {
       calendarApi.getEvents().forEach(event => {
        if (event.extendedProps?.channel == "online")
        {
          event.setProp("backgroundColor", '#daf1fe');
        }
        else if (event.extendedProps?.channel == "backoffice")
        {
          event.setProp("backgroundColor", '#eaeee0');
        }
        else
        {
          this.toolService.showConsoleLog(event.extendedProps?.channel + "8888888");
        }
      })
    }
    else
    {
      calendarApi.getEvents().forEach(event => {
        event.setProp("backgroundColor", '');
      });
    }
    this.isLoading = false;
  }

  checkViewDate() {
    let calendarApi = this.calendarComponent?.getApi();
    this.calendarCurrentDate = calendarApi?.getDate();
    //calendarApi?.gotoDate(this.calendarCurrentDate);
  }
  setViewDate() {
    var calendarDate = document.getElementById('calendarDate') as HTMLInputElement;
    if (calendarDate.value != null){
      let calendarApi = this.calendarComponent?.getApi();
      //this.calendarCurrentDate = calendarApi?.getDate();
      calendarDate.value = calendarApi?.getDate().toISOString();
      //calendarApi?.gotoDate(this.calendarCurrentDate);
    }
  }

  public goToDate(event) {
    var calendarDate = document.getElementById('calendarDate') as HTMLInputElement;
    this.toolService.showConsoleLog(calendarDate.value);
    //this.toolService.showConsoleLog(this.f['calendarDate']?.value.value);
    var calendarSelectedDate = moment(new Date(this.simpleForm.controls['calendarDate'] ? this.f['calendarDate'].value : null)).format("YYYY-MM-DD");
    //var calendarSelectedDate = this.f['calendarDate']?.value;
    //this.toolService.showConsoleLog(calendarSelectedDate);
    let calendarApi = this.calendarComponent?.getApi();
    calendarApi?.gotoDate(calendarDate.value);
  }


  ngAfterViewInit() {
    const calendarApi = this.calendarComponent?.getApi();
    setTimeout(() => {
      calendarApi?.updateSize();
      //calendarApi?.setOption("slotDuration", this.calendarTimeSlots);
    }, 1000);
  }

  loadCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getCourts(facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.courts = this.dbActiveData;
        this.courts.offers = res.offers;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadAddons = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getAddonsTable(facilityId)
      .then(res => {
        this.bookingAddons = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadBookingsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getBookingsCalendarHistory(facilityId)
      .then(res => {
        this.dbData = res;
        var dbFiltered = this.dbData.filter((booking => booking.eventType != 'disabled'))
        this.dbData.forEach(booking => {
          if (booking.eventType == 'disabled')
          {
              booking.resourceIds = booking.resourceIds?.split(',');
              var startDate = moment(booking.start).subtract(1, "days");
              var endDate = moment(booking.end);
              var startDT = moment(booking.start);
              var endTime = endDate.format("HH:mm:ss");

              while (startDate.isBefore(endDate, 'days')) 
              {
                startDate = startDate.add(1, 'days');
                var endDT = moment(startDate.format("YYYY-MM-DD") + ' ' + endTime, 'YYYY-MM-DD HH:mm:ss');
                booking.start = startDate.toDate();
                booking.end = endDT.toDate();
                const newObj = {...booking};
                dbFiltered.push(newObj);
              }
          }
        });
        this.calendarOptions.events = dbFiltered;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadCourtsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.courtsList = Array();
      this.localInterfaceSrv.getCourtsCalendar(facilityId)
      .then(res => {
        this.dbCourtData = res;
        this.dbCourtData.forEach(element => {
          this.courtsList.push(element.id);
        });
        this.calendarOptions.resources = this.dbCourtData;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadDisabledCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getDisabledCalendar(facilityId)
      .then(res => {
        this.disabledData = res;
        this.updateCalendar();
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }

  loadPaymentMethods = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getPaymentMethods(facilityId)
      .then(res => {
        this.paymentMethods = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

  loadTimingSlots = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getTimingSlots(facilityId)
      .then(res => {
        this.timingSlots = res.content;
        if (this.timingSlots == ''){
          var defaultSlots:Array<{nameEn: string, timingInMinutes: number}> = [];
          defaultSlots.push({
            nameEn: '30 Minutes',
            timingInMinutes: 30
          });
          defaultSlots.push({
            nameEn: '1 Hour',
            timingInMinutes: 60
          });
          defaultSlots.push({
            nameEn: '1 Hour 30 Minutes',
            timingInMinutes: 90
          });
          defaultSlots.push({
            nameEn: '2 Hours',
            timingInMinutes: 120
          });
          defaultSlots.push({
            nameEn: '2 Hours 30 Minutes',
            timingInMinutes: 150
          });
          defaultSlots.push({
            nameEn: '3 Hours',
            timingInMinutes: 180
          });
          defaultSlots.push({
            nameEn: '3 Hours 30 Minutes',
            timingInMinutes: 210
          });
          defaultSlots.push({
            nameEn: '4 Hours',
            timingInMinutes: 240
          });
          defaultSlots.push({
            nameEn: '4 Hours 30 Minutes',
            timingInMinutes: 270
          });
          defaultSlots.push({
            nameEn: '5 Hours',
            timingInMinutes: 300
          });
          defaultSlots.push({
            nameEn: '5 Hours 30 Minutes',
            timingInMinutes: 330
          });
          defaultSlots.push({
            nameEn: '6 Hours',
            timingInMinutes: 360
          });
          this.timingSlots = defaultSlots;
        }
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally(
      );
    });
  }

  
  cancelRecurrantBooking = (staffId,bookingId,bookingDisabledDate) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.cancelRecurrantBooking(staffId,bookingId,bookingDisabledDate)
      .then(res => {
        this.toastr.success('Reoccur Booking Removed', 'Success');
        this.reoccurBookingModal.hide();
        this.ngOnInit();
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.warning(err.desc, "Warning");
        this.reoccurBookingModal.hide();
      })
      .finally(()=>this.isLoading = false);
    });
  }

  public addBooking(selectedBooking)
  {
    this.f['bookingName'].enable();
    this.f['bookingMobile'].enable();
    this.f['bookingCountryCode'].enable();

    this.checkViewDate();
    this.isUpdate = false;
    this.bookingReOccur = false;
    this.bookingReOccurInstance = 1;
    var startDate = new Date(selectedBooking.start);
    var endDate = new Date(selectedBooking.end);
    const minutes = (endDate.getTime() - startDate.getTime())/60000;

    var selectedCourtId = selectedBooking.resource.id;
    var taxPercent = selectedBooking.resource.extendedProps.taxPercentage/100;
    this.taxOnus = selectedBooking.resource.extendedProps.taxOnus;
    var ccy = selectedBooking.resource.extendedProps.ccy;
    this.taxPercentage = taxPercent;
    this.ccy = ccy;
    var duration = (minutes);
    var vat = 0.0;
    var total;
    var subTotalPrice;
    var addon = 0.0;
    var addonTotalPrice = 0.0;

    //Ge max allowed timing slot from database
    var maxTimingSlot = Math.max.apply(Math, this.timingSlots.map(function(o) { return o.timingInMinutes; }));

    if (duration > maxTimingSlot)
    {
      this.toastr.warning("Selected duration exceeding max allowed slot by facility [" + maxTimingSlot + " minutes]", "Warning");
      return;
    }

    var isOffer = false;
    for (let offer of this.courts.offers)
    {
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));

      var offerStartDateM = moment(offer.startDT);
      var offerEndDateM = moment(offer.endDT);
      var startDateM = moment(startDate);
      var endDateM = moment(endDate);

      // this.toolService.showConsoleLog("offerStartDateM" + offerStartDateM);
      // this.toolService.showConsoleLog("offerEndDateM" + offerEndDateM);
      // this.toolService.showConsoleLog("startDateM" + startDateM);
      // this.toolService.showConsoleLog("endDateM" + endDateM);
      
      var courtIds = offer.courtIds?.split(',');
      var reoccurDays = offer.reoccurDays?.split(',');

      if (startDateM >= offerStartDateM && startDateM <= offerEndDateM && courtIds.indexOf(selectedCourtId) > -1)
      {

        var bookingStartDate = moment(startDate).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endDate).format("YYYY-MM-DD HH:mm:ss");
        
        var bookingEndDate = moment(endDate).format("YYYY-MM-DD");

        if (offer["endTimeOnly"] > offer["startTimeOnly"])
        {
          bookingEndDate = bookingStartDate;
        }
        var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");
        
        // this.toolService.showConsoleLog("offerStartTime" + offerStartTime);
        // this.toolService.showConsoleLog("offerEndTime" + offerEndTime);
        // this.toolService.showConsoleLog("bookingStartTime" + bookingStartTime);

        this.updateReoccurDay();

        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(selectedCourtId) > -1 && reoccurDays.indexOf(this.selectedReoccurDay.toLowerCase()) > -1)
        {
          this.toolService.showConsoleLog("isOffer");
          isOffer = true;
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          break;
        }
        else
        {
          for (let court of this.courts)
          {
            if (court.id == selectedCourtId)
            {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
            }
          }
        }
      }
      else
      {
        for (let court of this.courts)
        {
          if (court.id == selectedCourtId)
          {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
          }
        }
      }
    }

    if (!isOffer)
    {
      for (let court of this.courts)
      {
        if (court.id == selectedCourtId)
        {
          this.courtPrice30min = parseFloat(court["30minPrice"]);
          this.courtPrice60min = parseFloat(court["60minPrice"]);
          this.courtPrice90min = parseFloat(court["90minPrice"]);
          this.courtPrice120min = parseFloat(court["120minPrice"]);
        }
      }
    }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    subTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray)
    {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    var totalPriceWithAddon = (subTotalPrice + addonTotalPrice);
    vat = totalPriceWithAddon * taxPercent;
    var totalPriceWithVAT = totalPriceWithAddon + (this.taxOnus == '1' ? 0 : vat);
    total = totalPriceWithVAT;

    this.simpleForm.patchValue({court: selectedCourtId},{emitEvent: false});
    this.simpleForm.patchValue({bookingCountryCode: this.storageSrv.getFacilityCountryCode()},{emitEvent: false});
    this.simpleForm.patchValue({bookingDate: selectedBooking.start},{emitEvent: false});
    this.simpleForm.patchValue({bookingStartTime: selectedBooking.start},{emitEvent: false});
    this.simpleForm.patchValue({endTiming: duration},{emitEvent: false});
    this.simpleForm.patchValue({bookingPrice: subTotalPrice, disabled:false},{emitEvent: false});
    this.simpleForm.patchValue({bookingAddon: addon},{emitEvent: false});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(vat, 3), disabled:true},{emitEvent: false});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(total, 3), disabled:true},{emitEvent: false});
    this.simpleForm.patchValue({bookingReOccur: this.bookingReOccur},{emitEvent: false});
    this.simpleForm.patchValue({bookingReOccurInstance: this.bookingReOccurInstance},{emitEvent: false});
    this.simpleForm.patchValue({bookingTotalWithReoocur: total},{emitEvent: false});
    this.addBookingModal.show();
  }

  public manageBooking(info)
  {
    this.checkViewDate();
    this.isUpdate = true;
    if (info.event.extendedProps?.eventType == 'reoccur')
    {
      this.isBookingReoccur = true;
    }
    else
    {
      this.isBookingReoccur = false;
    }

    if (info.event.extendedProps?.channel == 'online')
    {
      this.f['bookingName'].disable();
      this.f['bookingMobile'].disable();
      this.f['bookingCountryCode'].disable();
    }
    else
    {
      this.f['bookingName'].enable();
      this.f['bookingMobile'].enable();
      this.f['bookingCountryCode'].enable();
    }

    var resources = info.event.getResources();
    var resourceId = resources.map(function(resource) { return resource.id });
    //var duration = info.event.extendedProps.duration;
    this.taxPercentage = info.event.extendedProps?.taxPercentage/100;
    var startDate = new Date(info.event.start);
    var endDate = new Date(info.event.end);
    const duration = (endDate.getTime() - startDate.getTime())/60000;

    this.bookingAddonsArray = [];
    if (info.event.extendedProps.addons != undefined){
    
    for (let item of info.event.extendedProps.addons)
    {
      this.bookingAddonsArray.push(item);
    }
  }
    this.existingBookingAddonArray = [...this.bookingAddonsArray];

    var isOffer = false;

    for (let offer of this.courts.offers)
    {
      isOffer = true;
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));

      if (startDate >= offerStartDate && startDate <= offerEndDate)
      {
        var bookingStartDate = moment(startDate).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endDate);
        
        var bookingEndDate = moment(endDate).format("YYYY-MM-DD");

        if (offer["endTimeOnly"] > offer["startTimeOnly"])
        {
          bookingEndDate = bookingStartDate;
        }

        var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var courtIds = offer.courtIds?.split(',');
        var reoccurDays = offer.reoccurDays?.split(',');

        this.selectedReoccurDay = moment(startDate).format("dddd");

        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(resourceId.toString()) > -1 && reoccurDays.indexOf(this.selectedReoccurDay.toLowerCase()) > -1)
        {
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          break;
        }
        else
        {
          for (let court of this.courts)
          {
            if (court.id == resourceId)
            {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
            }
          }
        }
      }
      else
      {
        for (let court of this.courts)
        {
          if (court.id == resourceId)
          {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
          }
        }
      }
    }

    if (!isOffer)
    {
      for (let court of this.courts)
      {
        if (court.id == resourceId)
        {
          this.courtPrice30min = parseFloat(court["30minPrice"]);
          this.courtPrice60min = parseFloat(court["60minPrice"]);
          this.courtPrice90min = parseFloat(court["90minPrice"]);
          this.courtPrice120min = parseFloat(court["120minPrice"]);
        }
      }
    }

    var payStatus = info.event.extendedProps?.paymentStatus;
    var paidDate = info.event.extendedProps?.paidDate != null ? new Date(info.event.extendedProps?.paidDate.replace(/-/g, "/")) : '';
    // if (info.event.extendedProps.paymentStatus == 1)
    // {
    //   payStatus = 'Paid';
    //   paidDate = new Date(info.event.extendedProps.paidDate);
    // }
    // else
    // {
    //   payStatus = 'Not Paid';
    // }
    var addon;
    if (info.event.extendedProps?.addon == null)
    {
      addon = 0;
    }
    else
    {
      addon = info.event.extendedProps?.addon;
    }
    this.bookingId = info.event.id;
    this.totalRemainingAmount = this.roundTo(parseFloat(info.event.extendedProps?.totalPrice == null ? '0' : info.event.extendedProps?.totalPrice) - parseFloat(info.event.extendedProps?.paidAmount == null ? '0' : info.event.extendedProps.paidAmount), 3);
    this.simpleForm.patchValue({bookingId: this.bookingId});
    this.simpleForm.patchValue({court: resourceId});
    this.simpleForm.patchValue({bookingCategoryId: info.event.extendedProps?.bookingCategoryId});
    this.simpleForm.patchValue({coachId: info.event.extendedProps?.coachId});
    this.simpleForm.patchValue({bookingName: info.event.extendedProps?.customerName});
    this.simpleForm.patchValue({bookingMobile: info.event.extendedProps?.customerMobile});
    this.simpleForm.patchValue({bookingCountryCode: info.event.extendedProps?.customerCountryCode});
    this.simpleForm.patchValue({bookingNotes: info.event.extendedProps?.notes});
    this.simpleForm.patchValue({bookingDate: info.event.start});
    this.simpleForm.patchValue({bookingStartTime: info.event.start});
    //this.simpleForm.patchValue({bookingEndTime: info.event.end});
    this.simpleForm.patchValue({endTiming: duration});
    this.simpleForm.patchValue({bookingPrice: this.roundTo(info.event.extendedProps?.subTotalPrice, 3)});
    this.simpleForm.patchValue({bookingAddon: addon});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(info.event.extendedProps?.tax, 3)});
    this.simpleForm.patchValue({bookingTotal: info.event.extendedProps?.totalPrice == null ? '0' : this.roundTo(info.event.extendedProps?.totalPrice, 3)});
    this.simpleForm.patchValue({bookingPayAmount: info.event.extendedProps?.paidAmount == null ? '0' : info.event.extendedProps?.paidAmount});
    this.simpleForm.patchValue({bookingPayStatus: payStatus});
    this.simpleForm.patchValue({bookingPayDate: paidDate});
    this.simpleForm.patchValue({totalRemainingAmount: this.totalRemainingAmount});
    this.simpleForm.patchValue({totalDiscount: info.event.extendedProps?.totalDiscount});
    this.simpleForm.get('paymentMethod').clearValidators();
    this.simpleForm.get('paymentMethod').updateValueAndValidity();
    this.simpleForm.get('endTiming').clearValidators();
    this.simpleForm.get('endTiming').updateValueAndValidity();

    this.openEventModal.show();
    this.openEventModal.dismissReason = 'backdrop-click';

  }
  public manageReoccurBooking(info)
  {
    this.checkViewDate();
    this.isUpdate = true;
    // var resources = info.event.getResources();
    // var resourceId = resources.map(function(resource) { return resource.id });
    this.bookingId = info.event.id;
    this.bookingReoccurDisabledDate = moment(new Date(info.event.start)).format("YYYY-MM-DD HH:mm:ss");
    this.toolService.showConsoleLog(this.bookingReoccurDisabledDate);
    this.reoccurBookingModal.show();
    this.openEventModal.dismissReason = 'backdrop-click';

  }
  public updateBooking(content: object) 
  {
    this.isLoading = true;
    var fd = new FormData();
    // stop here if form is invalid
    if (this.simpleForm.invalid) {
      var msg = "";
      if (this.simpleForm.controls['bookingName'].invalid)
      {
        msg = "booking Name is not valid."
      }
      else if (this.simpleForm.controls['bookingMobile'].invalid)
      {
        msg = "booking mobile is not valid."
      }
      else if (this.simpleForm.controls['bookingDate'].invalid)
      {
        msg = "bookingDate not valid"
      }
      else if (this.simpleForm.controls['bookingStartTime'].invalid)
      {
        msg = "Invalid bookingStartTime"
      }
      // else if (this.simpleForm.controls['bookingEndTime'].invalid)
      // {
      //   msg = "Invalid bookingEndTime"
      // }
      else
      {
        msg = 'An error has occured, please check missing fields and try again';
      }
      this.toastr.warning(msg, "Error");
      this.toastr.warning("Check Invalid Fields: " + this.findInvalidControls(), "Error");
      //this.showError("Check Invalid Fields: " + this.findInvalidControls());
      return;
    }
    this.toolService.showConsoleLog("this.f['court'].value" + this.f['court'].value);
    if (this.f['court'].value == 'null' || this.f['court'].value == 0 || this.f['court'].value == null)
    {
      msg = "Please select a court";
      this.toastr.warning(msg, "Error");
      return;
    }

    if (this.f['endTiming'].value == 'null' || this.f['endTiming'].value == 0 || this.f['endTiming'].value == null)
    {
      msg = "Please select a timing slot";
      this.toastr.warning(msg, "Error");
      return;
    }

    var bookingAddons;
    var newAddons;
    // if (this.bookingAddonsArray.length > 0)
    // {
    //   if (this.existingBookingAddonArray != null)
    //   {
    //     if (this.existingBookingAddonArray.length > 0)
    //     {
    //       newAddons = this.bookingAddonsArray.filter(item => this.existingBookingAddonArray.indexOf(item) < 0);
    //       bookingAddons = newAddons;
    //       //this.bookingAddon = this.bookingAddonsArray;
    //     }
    //     else
    //     {
    //       bookingAddons = this.bookingAddonsArray;
    //     }
    //   }
    //   else
    //   {
    //     bookingAddons = this.bookingAddonsArray;
    //   }
    // }
    bookingAddons = this.bookingAddonsArray;

    this.toolService.showConsoleLog('this.bookingAddonsArray.length' + this.bookingAddonsArray.length);
    //this.toolService.showConsoleLog('this.existingBookingAddonArray.length' + this.existingBookingAddonArray.length);
    this.toolService.showConsoleLog('newAddons' + newAddons);
    this.toolService.showConsoleLog('bookingAddons' + bookingAddons);


    bookingAddons = JSON.stringify(bookingAddons)

    //this.existingBookingAddonArray = this.bookingAddonsArray;
    
    // TODO: Use EventEmitter with form value
    this.court = this.f['court'].value
    this.bookingCategoryId = this.f['bookingCategoryId'].value
    this.coachId = this.f['coachId'].value
    this.paymentMethod = this.f['paymentMethod'].value
    this.bookingName = this.f['bookingName'].value
    this.bookingMobile = this.f['bookingMobile'].value
    this.bookingCountryCode = this.f['bookingCountryCode'].value
    this.bookingNotes = this.f['bookingNotes'].value
    this.bookingDate = this.f['bookingDate'].value
    this.bookingStartTime = this.f['bookingStartTime'].value
    this.endTiming = this.f['endTiming'].value
    //this.bookingEndTime = this.f['bookingEndTime'].value
    if (this.isUpdate)
    {
      //BEFORE CHANGE
      // this.bookingPrice = this.f['newBookingPrice'].value
      // this.bookingAddon = this.f['newBookingAddon'].value
      // this.bookingVAT = this.f['newBookingVAT'].value
      // this.bookingTotal = this.f['newBookingTotal'].value

      this.bookingPrice = this.f['bookingPrice'].value;
      this.bookingAddon = this.f['bookingAddon'].value;
      this.bookingVAT = this.f['bookingVAT'].value;
      this.bookingTotal = this.f['bookingTotal'].value;
    }
    else
    {
      this.bookingPrice = this.f['bookingPrice'].value;
      this.bookingAddon = this.f['bookingAddon'].value;
      this.bookingVAT = this.f['bookingVAT'].value;
      this.bookingTotal = this.f['bookingTotal'].value;
    }
    this.bookingReOccurDays = this.f['bookingReOccurDays'].value
    this.bookingReOccurInstance = this.f['bookingReOccurInstance'].value
    this.bookingTotalWithReoocur = this.f['bookingTotalWithReoocur'].value
    this.totalRemainingAmount = this.f['totalRemainingAmount'].value
    this.totalDiscount = this.f['totalDiscount'].value

    let formattedDate = (moment(new Date(this.f['bookingDate'].value))).format('YYYY-MM-DD')

    let startTimeDT = new Date(this.bookingStartTime);
    let endTimeDT = new Date(this.bookingStartTime);
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(this.endTiming));

    let formattedStartTime = startTimeDT.toTimeString().toString().substr(0, 8);
    let formattedEndTime = endTimeDT.toTimeString().toString().substr(0, 8);

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }  

    //const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;
    const duration = Number(this.endTiming);
    this.toolService.showConsoleLog("duration__" + duration)
    this.toolService.showConsoleLog("formattedDate" + formattedDate);

    var mobileCheck = /^\d+$/.test(this.bookingMobile);

    // if (duration > 120)
    // {
    //   this.toastr.error('Booking duration cannot exceed 120 minutes', "Error");
    //   return;
    // }
    if (duration == 0)
    {
      this.toastr.error('Booking start/end time cannot be on same time', "Error");
      this.isLoading = false;
      return;
    }
    else if (this.bookingMobile.length < 8)
    {
      this.toastr.error('Mobile Number is below valid length', "Error");
      this.isLoading = false;
      return;
    }
    // else if (this.bookingMobile.length > 8)
    // {
    //   this.toastr.error('Mobile Number exceeds valid length', "Error");
    //   return;
    // }
    else if (!mobileCheck)
    {
      this.toastr.error('Mobile Number is invalid', "Error");
      this.isLoading = false;
      return;
    }

    var startDate = formattedDate + ' ' + formattedStartTime;
    var endTime = formattedDate + ' ' + formattedEndTime;


    var dbFunction = '';
    if (this.isUpdate && !this.isReoccur)
    {
      dbFunction = 'updateBookingCalendar';
      fd.append('bookingId',this.bookingId);
      //fd.append('facilityId',this.facilityId);
    }
    else if (this.isUpdate && this.isReoccur)
    {
      dbFunction = 'updateBookingCalendar';
      fd.append('bookingId',this.bookingId);
      fd.append('bookingReOccurInstance',this.bookingReOccurInstance);
      fd.append('bookingTotalWithReoocur',this.bookingTotalWithReoocur);
      fd.append('bookingReoccurStartTime',formattedStartTime);
      fd.append('bookingReoccurEndTime',formattedEndTime);
    }
    else if (!this.isUpdate && this.isReoccur)
    {
      dbFunction = 'addBookingCalendar';
      //fd.append('userId',this.userId);
      //fd.append('facilityId',this.facilityId);
      fd.append('channel','backoffice');
      fd.append('bookingReOccurInstance',this.bookingReOccurInstance);
      fd.append('bookingTotalWithReoocur',this.bookingTotalWithReoocur);
      fd.append('bookingReoccurStartTime',formattedStartTime);
      fd.append('bookingReoccurEndTime',formattedEndTime);
    }
    else if (!this.isUpdate)
    {
      dbFunction = 'addBookingCalendar';
      //fd.append('userId',this.userId);
      fd.append('facilityId',this.facilityId);
      fd.append('channel','backoffice');
    }

    if (this.bookingNotes == null)
    {
      this.bookingNotes = null;
    }
    fd.append('staffId',this.storageSrv.getUser());
    fd.append('facilityId',this.facilityId);
    fd.append('courtId',this.court);
    fd.append('bookingCategoryId',this.bookingCategoryId);
    fd.append('coachId',this.coachId);
    fd.append('paymentMethodCode',this.paymentMethod);
    fd.append('bookingName',this.bookingName);
    fd.append('bookingMobile',this.bookingMobile);
    fd.append('bookingCountryCode',this.bookingCountryCode);
    fd.append('notes',this.bookingNotes==null ? '' : this.bookingNotes);
    fd.append('bookingDate',formattedDate);
    fd.append('bookingStartTime',startDate);
    fd.append('bookingEndTime',endTime);
    fd.append('bookingDuration',duration.toString());
    fd.append('bookingPrice', this.bookingPrice);
    fd.append('bookingAddon', this.bookingAddon);
    fd.append('bookingVAT',this.bookingVAT);
    fd.append('bookingTotal',this.bookingTotal);
    fd.append('isReoccur',String(this.isReoccur));
    fd.append('ccy',this.ccy);
    fd.append('taxPercentage', String(this.taxPercentage*100));
    fd.append('bookingAddonArray',bookingAddons);
    fd.append('totalRemainingAmount',this.totalRemainingAmount.toString());
    fd.append('totalDiscount',this.totalDiscount.toString());

    let headers = new Headers();
    headers.append('Content-Type','application/json');

    this.httpService.post(dbFunction, fd, '')
    .then(
      data => 
      {
        if (this.isUpdate) 
        {
          this.toolService.showConsoleLog(data);this.showSuccess('Booking updated');
          this.isLoading = false;
        } 
        else 
        {
          this.toolService.showConsoleLog(data);this.showSuccess('Booking added');
          this.isLoading = false;
        }
      },
      error => 
      {
        if (this.isUpdate) 
        {
          this.isError = true;
          this.toastr.error(error.desc, "Error");
          this.toolService.showConsoleLog(error);
          this.isLoading = false;
        } 
        else 
        {
          this.isError = true;
          this.toastr.error(error.desc, "Error");
          this.toolService.showConsoleLog(error);
          this.isLoading = false;
        }
      },
    ).catch();
  }
  public cancelBooking(content: object) 
  {
    var dbFunction = 'cancelBookingCalendar';

    var fd = new FormData();
    
    this.court = this.f['court'].value

    fd.append('bookingId',this.bookingId);
    fd.append('ownerId',this.ownerId);
    fd.append('facilityId',this.facilityId);
    fd.append('courtId',this.court);

    let headers = new Headers();
    headers.append('Content-Type','application/json');

    this.httpService.post(dbFunction, fd, '')
    .then(
      data => 
      {
        this.toolService.showConsoleLog(data);this.showSuccess('Booking cancelled');

      },
      error => 
      {
        if (this.isUpdate) 
        {
          this.isError = true;
          this.toastComp.doShow('Error', 'An error has occured in db, please check missing and try again');
          this.toolService.showConsoleLog(error);
        } 
        else 
        {
          this.isError = true;
          this.toastComp.doShow('Error', 'An error has occured in db, please check missing and try again');
          this.toolService.showConsoleLog(error);
        }
      },
    ).catch();
  }
  //Function 1
  public findInvalidControls() 
  {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }
  //Function 2
  get f() 
  { 
    return this.simpleForm.controls; 
  }
  //Function 3
  async showSuccess(msg) {
    await this.toastr.success(msg, 'Success');
    this.delay(1000).then(any=>{
      this.addBookingModal.hide();
      this.openEventModal.hide();
      this.simpleForm.patchValue({bookingName: ''});
      this.simpleForm.patchValue({totalDiscount: 0});
      this.closeModal();
      this.ngOnInit();
      //window.location.reload();
    });  
  }
  //Function 4
   delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
    }
  public updateCalendar()
  {
  }
  public closeModal()
  {
    this.simpleForm.patchValue({bookingName: null});
    this.simpleForm.patchValue({bookingMobile: null});
    this.simpleForm.patchValue({bookingCountryCode: null});
    this.simpleForm.patchValue({notes: null});
    this.memberId = null;
    this.membershipName = null;
    this.membershipDescription = null;
    // this.simpleForm.patchValue({newBookingPrice: null});
    // this.simpleForm.patchValue({newBookingAddon: null});
    // this.simpleForm.patchValue({newBookingVAT: null});
    // this.simpleForm.patchValue({newBookingTotal: null});
    this.bookingAddonsArray = [];
    if (this.isUpdate)
    {
      this.openEventModal.hide();
    }
    else
    {
      this.addBookingModal.hide();
    }
  }
  public openFullDetails()
  {
    if (this.isUpdate)
    {
      this.openEventModal.hide();
    }
    else
    {
      this.addBookingModal.hide();
    }
  }
  public roundTo = function(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };
  public updateReoccur()
  {
    this.updateReoccurDay();
    var status = this.f['bookingReOccur'].value;
    if (status == true)
    {
      this.bookingReOccur = true;
      //this.f['bookingReOccurDays'].enable();
      this.f['bookingReOccurInstance'].enable();
    }
    else
    {
      this.bookingReOccur = false;
      //this.f['bookingReOccur'].enable();
      this.f['bookingReOccurDays'].disable();
      this.f['bookingReOccurInstance'].disable();
      this.simpleForm.patchValue({bookingReOccurDays: null});
    }

    //this.toolService.showConsoleLog('selectedReoccurDay' + this.selectedReoccurDay);
    //this.bookingReOccur = true;
  }
  public updateReoccurDay()
  {
    var selectedDay = moment(new Date(this.f['bookingDate'].value)).format("dddd");
    this.selectedReoccurDay = selectedDay;
  }
  public updateReoccurTotal()
  {

  }
  public addAddon()
  {
    if (this.f['bookingAddonInstances'].value != '' && this.f['addon'].value != null)
    {
      var noInstances = parseInt(this.f['bookingAddonInstances'].value);
      var selectedAddon = this.f['addon'].value.split("|");
      this.toolService.showConsoleLog('selectedAddon' + JSON.stringify(selectedAddon));

      var price = parseFloat(selectedAddon[2]);
      if (noInstances > 0)
      {
      }
      else
      {
        return;
      }
      var total = noInstances * price;
      this.simpleForm.patchValue({bookingAddon: this.f['bookingAddon'].value + total});

      var isExisting = false;
      this.bookingAddonsArray.forEach(element => {
        if (element.id == selectedAddon[0])
        {
          isExisting = true;
          var index = this.bookingAddonsArray.splice(this.bookingAddonsArray.indexOf(element), 1);
          this.bookingAddonsArray.push({
            id: selectedAddon[0],
            name: selectedAddon[1],
            count: noInstances + element.count,
            price: price
          });
        }
      });

      if (!isExisting)
      {
        this.bookingAddonsArray.push({
          id: selectedAddon[0],
          name: selectedAddon[1],
          count: noInstances,
          price: price
        });
      }
    }
    this.updatePriceForAdd();
    this.isAddonBtn = false;
    this.simpleForm.patchValue({addon: null});
    this.simpleForm.patchValue({bookingAddonInstances: null, disabled:true});
    this.f['bookingAddonInstances'].disable();
  }
  public updateAddon()
  {
    this.isAddonBtn = true;
    this.f['bookingAddonInstances'].enable();
  }
  public removeAddon(addonId: number)
  {
    this.bookingAddonsArray = this.bookingAddonsArray.filter(({ id }) => id !== addonId); 
    this.updatePriceForAdd();       
  }
  public addAddonForEdit()
  {
    if (this.f['bookingAddonInstances'].value != '' && this.f['addon'].value != null)
    {
      var noInstances = parseInt(this.f['bookingAddonInstances'].value);
      var selectedAddon = this.f['addon'].value.split("|");
      this.toolService.showConsoleLog('selectedAddon' + JSON.stringify(selectedAddon));
      this.toolService.showConsoleLog('noInstances' + noInstances);

      var price = parseFloat(selectedAddon[2]);
      if (noInstances <= 0)
      {
        return;
      }

      var total = noInstances * price;
      this.simpleForm.patchValue({bookingAddon: this.f['bookingAddon'].value + total});
      
      var isExisting = false;
      this.toolService.showConsoleLog('step0');

      for (let index = 0; index < this.bookingAddonsArray.length; index++) {
        const element = this.bookingAddonsArray[index];
        this.toolService.showConsoleLog('step1');
        if (element.id == selectedAddon[0])
        {
          this.toolService.showConsoleLog('step2');
          isExisting = true;
          this.bookingAddonsArray.splice(this.bookingAddonsArray.indexOf(element), 1);
          this.bookingAddonsArray.push({
            id: selectedAddon[0],
            name: selectedAddon[1],
            count: parseInt(element.count.toString()) + parseInt(noInstances.toString()),
            price: price
          });
          break;
        }
      }
      
      if (!isExisting)
      {
        this.toolService.showConsoleLog('step3');
        this.bookingAddonsArray.push({
          id: selectedAddon[0],
          name: selectedAddon[1],
          count: noInstances,
          price: price
        });
      }
    }
    this.updatePriceForEdit();
    this.isAddonBtn = false;
    this.simpleForm.patchValue({addon: null});
    this.simpleForm.patchValue({bookingAddonInstances: null, disabled:true});
    this.f['bookingAddonInstances'].disable();
  }
  public updateAddonForEdit()
  {
    this.isAddonBtn = true;
    this.f['bookingAddonInstances'].enable();
  }
  public removeAddonForEdit(addonId: number)
  {
    this.bookingAddonsArray = this.bookingAddonsArray.filter(({ id }) => id !== addonId); 
    this.updatePriceForEdit();       
  }
  public updatePriceForAdd()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    this.isReoccur = this.f['bookingReOccur'].value;
    let selectedCourtId = this.f['court'].value != null ? this.f['court'].value : 0;

    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value)
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
    }  

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);

    var newSubTotalPrice = 0.0;
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    var courtId = null;

    if (this.f['court'].value == '' || this.f['court'].value == null || this.f['court'].value == '0')
    {
      selectedCourtId = null;
    }
    else
    {
      this.updateCourtOfferPrices(selectedCourtId, startTimeDT, endTimeDT)
    }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    subTotalPrice = this.courtPrice;

    //1
    newSubTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray)
    {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    //2
    newAddonPrice = addonTotalPrice;

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + (this.taxOnus == '1' ? 0 : vat);


    if (this.isReoccur)
    {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('subTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('vat' + newVATPrice);
    this.toolService.showConsoleLog('addon ' + newAddonPrice);
    this.toolService.showConsoleLog('total ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);

    this.simpleForm.patchValue({bookingPrice: this.roundTo(newSubTotalPrice, 3), disabled:false});
    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    // var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    // var newTotalPrice = parseFloat(this.f['newBookingTotal'].value);
    var newTotalPrice = newTotalPrice;
    var diff = (newTotalPrice - existingTotalPrice);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
  }
  public updatePriceForAddPrice()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    //var startDate = new Date(this.f['bookingStartTime'].value);
    //var endDate = new Date(this.f['bookingEndTime'].value);
    this.isReoccur = this.f['bookingReOccur'].value;
    let selectedCourtId = this.f['court'].value != null ? this.f['court'].value : 0;

    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value)
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }  

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    if (this.f['court'].value == '' || this.f['court'].value == null || this.f['court'].value == '0')
    {
      selectedCourtId = null;
    }
    else
    {
      this.updateCourtOfferPrices(selectedCourtId, startTimeDT, endTimeDT)
    }


    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);

    var newSubTotalPrice = parseFloat(this.f['bookingPrice'].value);
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    // if (this.f['bookingAddon'].value == '')
    // {
    //   addon = 0.0;
    // }
    // else if (parseFloat(this.f['bookingAddon'].value) > 0)
    // {
    //   addon = parseFloat(this.f['bookingAddon'].value);
    // }
    // else
    // {
    //   addon = addonTotalPrice;
    // }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    //newSubTotalPrice = this.courtPrice;

    for (let addonItem of this.bookingAddonsArray)
    {
      var addonItemPrice = addonItem.price * addonItem.count;
      addonTotalPrice = addonTotalPrice + addonItemPrice;
    }

    //2
    newAddonPrice = addonTotalPrice;

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + this.taxOnus == '1' ? 0 : vat;

    if (this.isReoccur)
    {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('subTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('vat ' + newVATPrice);
    this.toolService.showConsoleLog('addon ' + newAddonPrice);
    this.toolService.showConsoleLog('total ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);

    //this.simpleForm.patchValue({bookingPrice: this.roundTo(newSubTotalPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    // var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    // var newTotalPrice = parseFloat(this.f['newBookingTotal'].value);
    var newTotalPrice = newTotalPrice;
    var diff = (newTotalPrice - existingTotalPrice);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
  }
  public updatePriceForEditPrice()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    //var startDate = new Date(this.f['bookingStartTime'].value);
    //var endDate = new Date(this.f['bookingEndTime'].value);
    this.isReoccur = this.f['bookingReOccur'].value;

    
    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value)
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }  

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;
    this.toolService.showConsoleLog("duration__" + duration)

    // if (duration > 120)
    // {
    //   var minutesToAdd=30;
    //   var futureDate = new Date(startDate.getTime() + minutesToAdd*60000);
    //   this.simpleForm.patchValue({bookingStartTime: futureDate});
    // }

    //FOR TESTING TO BE REMOVED
    //this.isReoccur = false;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }

    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value === '' ? '0' : this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    var existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    var paidAmount = parseFloat(this.f['bookingPayAmount'].value);

    var newSubTotalPrice = isNaN(existingSubTotalPrice) ? 0 : existingSubTotalPrice;
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    //newSubTotalPrice = this.courtPrice;

    if (this.bookingAddonsArray.length > 0)
    {
      if (this.existingBookingAddonArray != null)
      {
        if (this.bookingAddonsArray.length >= this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice + addonItemPrice;
          }
          newAddonPrice = addonTotalPrice;
        }
        else if (this.bookingAddonsArray.length < this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice - addonItemPrice;
          }
          newAddonPrice = addonTotalPrice * -1;
        }
        else
        {
          newAddonPrice = existingAddonPrice;
        }
      }
      else
      {
        newAddonPrice = existingAddonPrice;
      }
    }
    else if (this.bookingAddonsArray.length == 0)
    {
      newAddonPrice = 0;
    }
    else
    {
      newAddonPrice = existingAddonPrice;
    }


    this.toolService.showConsoleLog('addonTotalPrice ' + addonTotalPrice);
    this.toolService.showConsoleLog('existingAddonPrice ' + existingAddonPrice);

    //2

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    //4
    newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;

    if (this.isReoccur)
    {
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('this.taxPercentage ' + this.taxPercentage);
    this.toolService.showConsoleLog('newSubTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('newVATPrice ' + newVATPrice);
    this.toolService.showConsoleLog('newAddonPrice ' + newAddonPrice);
    this.toolService.showConsoleLog('newTotalPrice ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);


    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    var diff = (newTotalPrice - paidAmount);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});

  }
  public updatePriceForEdit()
  {
    var subTotalPrice;
    var addon;
    var vat;
    var total;
    var totalReoccur;
    var addonTotalPrice = 0.0;
    //var startDate = new Date(this.f['bookingStartTime'].value);
    //var endDate = new Date(this.f['bookingEndTime'].value);
    this.isReoccur = this.f['bookingReOccur'].value;
    this.totalDiscount = this.f['totalDiscount'].value;

    
    let startTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTimeDT = new Date(this.f['bookingStartTime'].value);
    let endTiming = this.f['endTiming'].value
    endTimeDT.setMinutes(endTimeDT.getMinutes() + Number(endTiming));

    if (endTimeDT < startTimeDT) {
      endTimeDT.setDate(endTimeDT.getDate() + 1);
      }  

    const duration = (endTimeDT.getTime() - startTimeDT.getTime())/60000;

    //FOR TESTING TO BE REMOVED
    //this.isReoccur = false;

    var reoccurInstances;
    if (this.isReoccur)
    {
      if (this.f['bookingReOccurInstance'].value == '' || this.f['bookingReOccurInstance'].value == null || this.f['bookingReOccurInstance'].value == '0')
      {
        reoccurInstances = 1;
      }
      else
      {
        reoccurInstances = parseInt(this.f['bookingReOccurInstance'].value);
      }
    }


    var existingSubTotalPrice = parseFloat(this.f['bookingPrice'].value === '' ? '0' : this.f['bookingPrice'].value);
    var existingAddonPrice = parseFloat(this.f['bookingAddon'].value);
    var existingVATPrice = parseFloat(this.f['bookingVAT'].value);
    const existingTotalPrice = parseFloat(this.f['bookingTotal'].value);
    const paidAmount = parseFloat(this.f['bookingPayAmount'].value);

    var newSubTotalPrice = parseFloat(this.f['bookingPrice'].value === '' ? '0' : this.f['bookingPrice'].value);
    var newAddonPrice = 0.0;
    var newVATPrice = 0.0;
    var newTotalPrice = 0.0;

    var courtId = null;

    if (this.f['court'].value == '' || this.f['court'].value == null || this.f['court'].value == '0')
    {
      courtId = null;
    }
    else
    {
      this.toolService.showConsoleLog("eeeeee");
      courtId = parseInt(this.f['court'].value);
      this.updateCourtOfferPrices(courtId, startTimeDT, endTimeDT)
    }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    //subTotalPrice = this.courtPrice;

    //1
    newSubTotalPrice = this.courtPrice;

    if (this.bookingAddonsArray.length > 0)
    {
      if (this.existingBookingAddonArray != null)
      {
        if (this.bookingAddonsArray.length >= this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice + addonItemPrice;
          }
          newAddonPrice = addonTotalPrice;
        }
        else if (this.bookingAddonsArray.length < this.existingBookingAddonArray.length)
        {
          for (let addonItem of this.bookingAddonsArray)
          {
            var addonItemPrice = addonItem.price * addonItem.count;
            addonTotalPrice = addonTotalPrice - addonItemPrice;
          }
          newAddonPrice = addonTotalPrice * -1;
        }
        else
        {
          newAddonPrice = existingAddonPrice;
        }
      }
      else
      {
        newAddonPrice = existingAddonPrice;
      }
    }
    else if (this.bookingAddonsArray.length == 0)
    {
      newAddonPrice = 0;
    }
    else
    {
      newAddonPrice = existingAddonPrice;
    }
    //2

    //3
    var totalPriceWithAddon = (newSubTotalPrice + newAddonPrice);
    vat = totalPriceWithAddon * this.taxPercentage;
    newVATPrice = vat;

    if (this.totalDiscount > 0)
    {
      newSubTotalPrice = newSubTotalPrice - (newSubTotalPrice * (this.totalDiscount/100));
    }
    else
    {
      this.totalDiscount = 0;
    }

    newTotalPrice = newSubTotalPrice + newAddonPrice + newVATPrice;

    //4

    if (this.isReoccur)
    {
      //var subTotalPriceR = subTotalPrice * reoccurInstances;
      //var vatR = vat * reoccurInstances;
      totalReoccur = total * reoccurInstances;
    }

    this.toolService.showConsoleLog('duration ' + duration);
    this.toolService.showConsoleLog('courtPrice ' + this.courtPrice);
    this.toolService.showConsoleLog('this.taxPercentage ' + this.taxPercentage);
    this.toolService.showConsoleLog('newSubTotalPrice ' + newSubTotalPrice);
    this.toolService.showConsoleLog('newVATPrice ' + newVATPrice);
    this.toolService.showConsoleLog('newAddonPrice ' + newAddonPrice);
    this.toolService.showConsoleLog('newTotalPrice ' + newTotalPrice);
    this.toolService.showConsoleLog('totalReoccur ' + totalReoccur);
    this.toolService.showConsoleLog('totalDiscount ' + this.totalDiscount);

    this.simpleForm.patchValue({bookingPrice: this.roundTo(newSubTotalPrice, 3), disabled:false});
    this.simpleForm.patchValue({bookingAddon: this.roundTo(newAddonPrice, 3)});
    this.simpleForm.patchValue({bookingVAT: this.roundTo(newVATPrice, 3), disabled:true});
    this.simpleForm.patchValue({bookingTotal: this.roundTo(newTotalPrice, 3)});
    this.simpleForm.patchValue({bookingTotalWithReoocur: this.roundTo(totalReoccur, 3)});

    var diff = (newTotalPrice - paidAmount);
    this.simpleForm.patchValue({totalRemainingAmount: this.roundTo(diff, 3)});
  }
  public goFullDetails(bookingId) {
    this.router.navigate([`/booking/details/${bookingId}`], {state: {bookingId: bookingId}, relativeTo: this.route});
  }
  updateCourtOfferPrices(selectedCourtId, startTimeDT, endTimeDT)
  {
    var isOffer = false;
    for (let offer of this.courts.offers)
    {
      isOffer = true;
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));

      var courtIds = offer.courtIds?.split(',');
      var reoccurDays = offer.reoccurDays?.split(',');

      if (startTimeDT >= offerStartDate && startTimeDT <= offerEndDate && courtIds.indexOf(selectedCourtId.toString()) > -1)
      {

        // var bookingStartTime = moment(startTimeDT).format("HH:mm:ss");
        // var bookingEndTime = moment(endTimeDT).format("HH:mm:ss");
        // var offerStartTime = moment(new Date(offer["startTime"])).format("HH:mm:ss");
        // var offerEndTime = moment(new Date(offer["endTime"])).format("HH:mm:ss");

        var bookingStartDate = moment(startTimeDT).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(startTimeDT).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endTimeDT);
        
        var bookingEndDate = moment(endTimeDT).format("YYYY-MM-DD");

        if (offer["endTimeOnly"] > offer["startTimeOnly"])
        {
          bookingEndDate = bookingStartDate;
        }

        var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");
        
        // if (bookingEndTime.toString() == "00:00:00")
        // {
        //   bookingEndTime = '23:59:59';
        // }

        // this.toolService.showConsoleLog("offerStartTime" + offerStartTime);
        // this.toolService.showConsoleLog("offerEndTime" + offerEndTime);
        // this.toolService.showConsoleLog("bookingStartTime" + bookingStartTime);
        // this.toolService.showConsoleLog("bookingEndDate" + bookingEndDate);
        
        this.updateReoccurDay();

        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(selectedCourtId.toString()) > -1 && reoccurDays.indexOf(this.selectedReoccurDay.toLowerCase()) > -1)
        {
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          return;
        }
        else
        {
          for (let court of this.courts)
          {
            if (court.id == selectedCourtId)
            {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
            }
          }
        }
      }
      else
      {
        for (let court of this.courts)
        {
          if (court.id == selectedCourtId)
          {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
          }
        }
      }
    }

    for (let court of this.courts)
    {
      if (court.id == selectedCourtId)
      {
        this.courtPrice30min = parseFloat(court["30minPrice"]);
        this.courtPrice60min = parseFloat(court["60minPrice"]);
        this.courtPrice90min = parseFloat(court["90minPrice"]);
        this.courtPrice120min = parseFloat(court["120minPrice"]);
      }
    }

  }
  getCustomerInfo = () => {
    var mobile = this.f['bookingMobile'].value;
    var countryCode = this.f['bookingCountryCode'].value;
    if (mobile != '' && mobile != null && mobile != '0' && mobile.length >= 8 &&
      countryCode != '' && countryCode != null && countryCode != '0' && countryCode.length == 3)
    {
      return new Promise<any>(async (resolve, reject) => {
        this.localInterfaceSrv.getCustomerInfo(mobile, countryCode)
        .then(res => {
          if (res.content.customerName != "" && res.content.customerName != null)
          {
            this.f['bookingName'].setValue(res.content.customerName);
            this.memberId = res.content.membershipId;
            this.membershipName = res.content.membershipName;
            this.membershipDescription = res.content.membershipDescription;
          }
          resolve(res);
        })
        .catch(err => { 
          reject(err); 
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(() => this.isLoading = false);
      });
    }
  }
  get simpleProps() {
    const content = this.sanitize(
      '<h3 class="popover-header">' + this.membershipName + '</h3> <div class="popover-body">' + this.membershipDescription + '</div>'
    );
    return { ...this.tippyPropsDefault, content, trigger: 'mouseenter focus' };
  }

  tippyPropsDefault = {
    allowHTML: true,
    appendTo: 'parent',
    theme: 'cpopover',
    trigger: 'click',
    placement: 'right'
  };

  sanitize(value) {
    return this.sanitizer.sanitize(SecurityContext.HTML, value);
  }
  loadBookingCategory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getBookingCategory(facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.bookingCategories = this.dbActiveData;
        this.bookingCategories.content = this.dbActiveData;
        //this.taxPercentage = this.courts.content.taxPercentage/100;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
  loadCoaches = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getCoachesByFacility()
      .then(res => {
        this.responseData = Object.values(res);
        this.coaches = res;
        //this.taxPercentage = this.courts.content.taxPercentage/100;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
  // Auto refresh
  private autoRefreshInterval: any;
  toggleAutoRefresh(event: any) {
    if (event.checked) {
      this.autoRefreshInterval = setInterval(() => {
        this.getCurrentData();
      }, 30 * 1000); // 30 seconds
    } else {
      if (this.autoRefreshInterval) {
        clearInterval(this.autoRefreshInterval);
      }
    }
  }
}
